module.exports = __webpack_public_path__ + "static/media/check (1).3db3797d.svg";